import type { CountDownProps } from '../CpnCountDown/types'

type TextType = 'title' | 'subtitle' | 'subheading'

type TextContent = {
  type: TextType
  text: string
}

interface BaseType {
  text?: string
  target?: string
  end?: string
  copy?: CountDownProps['copy']
}

type ButtonContent = {
  type: 'button'
  text: string
  target?: string
  cns?: string
  onClick?: () => void
}

type ButtonsContent = {
  type: 'buttons'
  buttons: Omit<ButtonContent, 'type'>[]
}

type CountDownContent = {
  type: 'countdown'
} & CountDownProps

type BannerContent = TextContent | ButtonContent | ButtonsContent | CountDownContent

export type BannerProps = {
  id?: string
  image: string
  imageMob?: string
  imageLink?: string
  content?: BannerContent[]
  cns?: {
    container?: string
    picture?: string
    image?: string
    box?: string
    contentBox?: string
    content?: string
    subheading?: string
    title?: string
    subtitle?: string
    buttonBox?: string
    button?: string
    countdown?: CountDownProps['cns']
  }
}
